import { 
    ACCOUNTS,
    CARDS,
    LOANSANDMORTGAGES,
    DEPOSITS,
    INVESTMENTS
} from 'constants/aggregator/products'

import { 
    ACCOUNTSURL,
    CARDSURL,
    LOANSANDMORTGAGESURL,
    DEPOSITSURL,
    INVESTMENTSURL
} from 'constants/aggregator/url'


const typeToUrlString = {
    [ACCOUNTS]: ACCOUNTSURL,
    [CARDS]: CARDSURL,
    [LOANSANDMORTGAGES]: LOANSANDMORTGAGESURL,
    [DEPOSITS]: DEPOSITSURL,
    [INVESTMENTS]: INVESTMENTSURL
}

const typeFromUrlString = {
    [ACCOUNTSURL]: ACCOUNTS,
    [CARDSURL]: CARDS,
    [LOANSANDMORTGAGESURL]: LOANSANDMORTGAGES,
    [DEPOSITSURL]: DEPOSITS,
    [INVESTMENTSURL]: INVESTMENTS
}

const getTypeFromString = (s) => typeFromUrlString[s]
const getStringFromType = (s) => typeToUrlString[s]

export { 
	getStringFromType,
	getTypeFromString
}